'use client'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { ApplicableTransactionAction } from '@marketplace-web/messaging/conversation-messaging-data'
import { clickEvent } from '@marketplace-web/messaging/tracking-data'
import { ITEM_UPLOAD_URL } from '@marketplace-web/messaging/navigation-feature'

import useTransactionActions from '../../hooks/useTransactionActions/useTransactionActions'

type Props = ConversationActionProps

const UploadItem = ({ title, primary, size, theme, inverse }: Props) => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()

  const transactionId = conversation?.transactionId
  const userSide = conversation?.transaction?.userSide
  const shipmentStatus = conversation?.transaction?.shipment?.status
  const transactionStatus = conversation?.transaction?.status
  const { applicableTransactionActions } = useTransactionActions()

  const trackButtonClick = () => {
    if (!transactionId) return

    const isFeedbackActionAvailable =
      applicableTransactionActions.includes(ApplicableTransactionAction.LeaveFeedback) || false

    const targetDetails: Record<string, unknown> = {
      user_side: userSide,
      transaction_id: transactionId,
      shipment_status: shipmentStatus,
      transaction_status: transactionStatus,
      is_feedback_action_available: isFeedbackActionAvailable,
    }

    track(
      clickEvent({
        target: 'upload_item',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  const handleClick = () => {
    trackButtonClick()

    navigateToPage(ITEM_UPLOAD_URL)
  }

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
    />
  )
}

export default UploadItem
